import create, { GetState, SetState } from "zustand";
import { GenericObjectType } from "../types/global";
import { SignUpDataType } from "../types/signup.types";

export type SignupStoreType = {
  signInData?: GenericObjectType;
  setSignInData: (signInData?: GenericObjectType) => void;
  signInInputsErrors?: GenericObjectType;
  setSignInInputsErrors: (signUpInputsErrors: GenericObjectType) => void;
};

export const useSignInStore = create<SignupStoreType>(
  (set: SetState<SignupStoreType>, get: GetState<SignupStoreType>) => ({
    setSignInData: (signInData?: SignUpDataType): void => {
      set((state) => {
        state.signInData = signInData;
      });
    },
    signInInputsErrors: {},
    setSignInInputsErrors: (signInInputsErrors: GenericObjectType): void => {
      set((state) => {
        state.signInInputsErrors = signInInputsErrors;
      });
    },
  })
);

export default useSignInStore;
